import Button from "@/components/Button";
import { selectClubImportState } from "@/redux/clubImport/clubImportSlice";
import { useTranslation } from "@repo/shared/i18n";
import { ChevronLeft } from "lucide-react";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";

import { CompletedStepIcon } from "../CompletedStepIcon";

export const SetupExtensionSection = () => {
  const { t } = useTranslation(["clubImport", "common"]);
  const { extensionEnabledStatus, hasEaAccess } = useSelector(
    selectClubImportState,
  );
  const navigate = useNavigate();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <div className="bg-panel-base min-h-screen px-4 py-6">
      <h1 className="text-white text-lg font-bold mb-4">
        {t("mobile.setup.title")}
      </h1>

      <div className="bg-panel-background border border-new-gray-700 rounded-[15px] p-4 flex flex-col mb-4">
        {/* Step A */}

        <div className="flex flex-col gap-2.5">
          <div className="flex items-center my-2">
            <h3 className="text-white text-sm font-bold">
              {t("mobile.setup.stepA")}
            </h3>
          </div>
          <p className="text-white text-sm leading-5">
            {t("mobile.setup.clickExtensionIcon")}
          </p>
          <p className="text-white text-sm leading-5">
            {t("mobile.setup.stepA2")}
          </p>
          <p className="text-white text-sm leading-5">
            {t("mobile.setup.stepA3")}
          </p>
          <img
            src={
              import.meta.env.VITE_APP_ASSETS_BASE_URL +
              "/import-tutorial/mobile/stepA.gif"
            }
            alt={t("mobile.setup.stepA")}
            className="w-[321px] rounded-[15px]"
          />
        </div>
      </div>
      <div className="bg-panel-background border border-new-gray-700 rounded-[15px] p-4 flex flex-col">
        <div className="flex flex-col gap-2.5">
          <div className="flex items-center gap-2.5">
            <h3 className="text-white text-sm font-bold">
              {t("mobile.setup.stepB")}
            </h3>
            <CompletedStepIcon
              completed={extensionEnabledStatus === "enabled"}
            />
          </div>

          <div className="flex flex-col gap-2.5">
            <p className="text-white text-sm leading-5">
              {t("mobile.setup.clickExtensionIcon")}
            </p>
            <p className="text-white text-sm leading-5">
              {t("mobile.setup.stepB2")}
            </p>
            <p className="text-white text-sm leading-5">
              {t("mobile.setup.stepB3")}
            </p>
            <p className="text-white text-sm leading-5">
              {t("mobile.setup.stepB4")}
            </p>
          </div>

          <img
            src={
              import.meta.env.VITE_APP_ASSETS_BASE_URL +
              "/import-tutorial/mobile/stepB.gif"
            }
            className="w-[321px] rounded-[15px]"
            alt={t("mobile.setup.stepB")}
          />
          {/* Tips */}
          <div className="flex flex-col gap-5 italic text-dark-secondary text-sm leading-5">
            <p>{t("mobile.setup.tipAlwaysAllow")}</p>
            <p>{t("mobile.setup.tipEveryWebsite")}</p>
            {!hasEaAccess && (
              <p className="text-[#F59E0B] ">
                {t("mobile.setup.noEaAccessWarning")}
              </p>
            )}
          </div>
        </div>

        {/* Navigation Buttons */}
        <div className="flex gap-10 justify-center mt-10">
          <Button
            variant="tertiary"
            label={
              <span className="flex items-center  px-2">
                <ChevronLeft className="w-6 h-6" />
                {t("common:back")}
              </span>
            }
            onClick={() => navigate("/club-import-tutorial")}
          />
          <Button
            variant={
              extensionEnabledStatus === "enabled" ? "primary" : "disabled"
            }
            label={
              <span className="flex items-center px-2">{t("common:done")}</span>
            }
            onClick={() => navigate("/club-import-tutorial")}
            disabled={extensionEnabledStatus !== "enabled"}
          />
        </div>
      </div>
    </div>
  );
};
